module.exports = __webpack_public_path__ + "static/media/li-4.3e48f63b.png";